import { useEffect, useState } from 'react';
import { ItfEcoCartItem } from '../../type';
import { ItfCouponHitProduct, ItfEcoCartCoupon } from './type';
import getLocal from 'eco-design-reliance/getLocal';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
// import { saveAICookieForShopify, saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import ClipboardJS from 'clipboard';
import { EcoCartCouponCopy, EcoCartCouponCoupon } from './icons';
import EcoCartCountdown from '../EcoCartCountdown';
import './index.scss';
import useEcoCart from '../../useEcoCart';
import { i18n } from '../../i18n';

const EcoCartCoupon: React.FC<ItfEcoCartCoupon> = ({ item }) => {
    const { locale = '' } = getLocal();
    const t = i18n?.[locale] || i18n.en;
    const { coupon } = useEcoCart();
    const [hitProduct, setHitProduct] = useState<ItfCouponHitProduct | null>(null);
    const [copyed, setCopyed] = useState<string>('');

    // @ts-ignore
    const clipboard = typeof window !== 'undefined' ? new ClipboardJS(`.eco-cart-item-coupon .eco-cart-item-coupon-code`) : null;
    const copyText = (cart: ItfEcoCartItem) => {
        setCopyed(cart.variantId);
        const timer = setTimeout(() => {
            setCopyed('');
            if (timer) {
                clearTimeout(timer);
            }
        }, 3000);
    };

    useEffect(() => {
        // coupon/gift 命中购物车中产品
        if (coupon && coupon?.hitProducts && Array.isArray(coupon?.hitProducts)) {
            const target: ItfCouponHitProduct | undefined = coupon?.hitProducts?.find((pd: ItfCouponHitProduct) => pd.variantId === item.variantId);
            if (target) {
                setHitProduct(target);
            }
        }
    }, [coupon, item]);

    return (
        <>
            {coupon?.ruleType === 'COUPONS' && hitProduct && (
                <div className="eco-cart-item-coupon">
                    <div className="eco-cart-item-coupon-info">
                        <div className="eco-cart-item-coupon-code" onClick={() => copyText(item)} data-clipboard-text={coupon.code}>
                            <div className="code-icon">{EcoCartCouponCoupon}</div>
                            <span className="code-text">
                                {copyed === item?.variantId ? t.cart_coupon_copied : `***${coupon.code?.slice(coupon.code?.length - 4)}`}
                            </span>
                            <div className="code-icon icon-copy">{EcoCartCouponCopy}</div>
                        </div>
                        {Number(hitProduct.discount) > 0 && (
                            <span className="eco-cart-item-coupon-discount">
                                {'-'}
                                {FormatMoneyLocal(hitProduct.discount, locale)}
                            </span>
                        )}
                    </div>
                    <p className="eco-cart-item-coupon-line"></p>
                    <EcoCartCountdown />
                </div>
            )}
        </>
    );
};

export default EcoCartCoupon;
